import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { recruiterClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";
import { RequestOtpPayload } from "./dto";

export const passwordOtpRequest = (data: RequestOtpPayload): Promise<{}> => {
  return recruiterClient.httpClient.post(PATHS.recruiter.changePassword.requestOtp, data);
};

export const useRecruiterPasswordOtpRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.RECRUITER] });
      notification.success({
        message: "Otp Sent",
        description: "Otp is successfully sent to the given email.",
      });
    },

    mutationFn: passwordOtpRequest,
  });
};
